export default {
    created() {
        // Get notified when a token is refreshed
        if (!window.FirebasePlugin) {
            return
        }

        window.FirebasePlugin.onTokenRefresh((token) => {
            // save this server-side and use it to push notifications to this device
            this.onTokenRefresh(token)

        }, (error) => {
            // conssole.log(error)
        })

        // Get notified when the user opens a notification
        window.FirebasePlugin.onMessageReceived((message) => {
            this.onMessageReceived(message)

        }, (error) => {
            // console.error(error)
        })
    },

    methods: {
        async registerDevice(customerId) {
            return this.getDeviceToken()
                .then(token => {
                    if (!token) {
                        return
                    }

                    // alert(token);
                    return this.api.postData('/my/devices', {}, {
                        customer_id: customerId,
                        device_uuid: _.get(window, 'device.uuid'),
                        device_token: token,
                        active: 1,
                    });
                });
        },

        async getDeviceToken() {
            if (!window.FirebasePlugin) {
                console.log('No FirebasePlugin')
                return Promise.resolve(null)
            }

            return this._checkPermission()
                .then(hasPermission => {
                    if (hasPermission) {
                        return hasPermission
                    }

                    return this._grantPermission()
                })
                .then(hasPermission => {
                    if (!hasPermission) {
                        return resolve(null)
                    }

                    return this._getDeviceToken()
                })
                .catch(err => reject(err))
        },

        _getDeviceToken() {
            return new Promise((resolve, reject) => {
                window.FirebasePlugin.getToken((token) => {
                    // save this server-side and use it to push notifications to this device
                    console.log(token)
                    return resolve(token)
                }, (error) => {
                    console.error(error)
                    return reject(error)
                })
            })
        },

        _checkPermission() {
            return new Promise((resolve, reject) => {
                window.FirebasePlugin.hasPermission((hasPermission) => {
                    resolve(hasPermission)
                }, (err) => reject(err))
            })
        },

        _grantPermission() {
            return new Promise((resolve, reject) => {
                window.FirebasePlugin.grantPermission((hasPermission) => {
                    resolve(hasPermission)
                }, (err) => reject(err))
            })
        },

        onTokenRefresh(token) {

        },

        onMessageReceived(message) {
            if (!message.tap) {
                return
            }

            if (message.route) {
                window.dispatchEvent(new CustomEvent('notification', { detail: message }))
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/PushNotification.js